import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'

import type { DefaultShiftsDispatch } from './reducers/defaultShifts'
import defaultShiftsReducer, {
  DefaultShiftsState,
  initialDefaultShiftsState,
} from './reducers/defaultShifts'

type Context = [DefaultShiftsState, DefaultShiftsDispatch]

const { context: DefaultShiftsContext, hook: useDefaultShifts } = createContext<Context>()

const DefaultShiftsProvider = ({
  children,
  contractVersions,
}: React.PropsWithChildren<{ contractVersions: ContractVersions }>) => {
  const memoizedReducer = useCallback(defaultShiftsReducer, [])
  const [state, dispatch] = React.useReducer(
    memoizedReducer,
    initialDefaultShiftsState(contractVersions)
  )

  return (
    <DefaultShiftsContext.Provider value={[state, dispatch]}>
      {children}
    </DefaultShiftsContext.Provider>
  )
}

export { DefaultShiftsProvider, useDefaultShifts }
